module.exports = __webpack_public_path__ + "static/img/logo.f1ba3deb.png";